export const RISKS = [
  'Непогашенная ипотека',
  'Несовершеннолетние собственники имеют право на проживание',
  'Долги и банкротство собственника',
  'Предыдущая сделка с этой недвижимостью недействительна',
  'Дом подлежит сносу',
  'Скрытые собственники не согласны на продажу',
  'Недвижимость под арестом',
];
